import { Newspaper } from "@mui/icons-material";
import { LandingPage } from "../pages/landing-page";
import { AppContainer } from "../pages/app-container";
import { PoseMirror } from "../pages/pose-mirror";
import { GestureExtraction } from "../pages/gesture-extraction-page";
import { SettingPage } from "../pages/setting-page";
import { ListingPage } from "../pages/listing-page";
import { AdminPage } from "../pages/admin-page";
import { AvatarMirrorPage } from "../pages/avatar-mirror-page";
import { ResultPage } from "../pages/result-page";

const routes = [
  {
    name: "Landing",
    key: "landing-page",
    icon: <Newspaper />,
    route: "/",
    routeNav: "/",
    component: <LandingPage />,
  },
  {
    name: "Container",
    key: "app-container",
    icon: <Newspaper />,
    route: "/app-container/",
    routeNav: "/app-container",
    component: <AppContainer />,
  },
  {
    name: "PoseMirror",
    key: "pose-mirror",
    icon: <Newspaper />,
    route: "/pose-mirror/:id",
    routeNav: "/pose-mirror",
    component: <PoseMirror />,
  },
  {
    name: "Setting",
    key: "setting",
    icon: <Newspaper />,
    route: "/setting/",
    routeNav: "/setting",
    component: <SettingPage />,
  },
  {
    name: "Gesture Extraction",
    key: "gesture-extraction",
    icon: <Newspaper />,
    route: "/gesture-extraction/",
    routeNav: "/gesture-extraction",
    component: <GestureExtraction />,
  },
  {
    name: "Listings",
    key: "listing-page",
    icon: <Newspaper />,
    route: "/listing-page/",
    routeNav: "/listing-page",
    component: <ListingPage />,
  },
  {
    name: "Admin",
    key: "admin-page",
    icon: <Newspaper />,
    route: "/admin-page/",
    routeNav: "/admin-page",
    component: <AdminPage />,
  },
  {
    name: "Avatar",
    key: "avatar-mirror-page",
    icon: <Newspaper />,
    route: "/avatar-mirror-page/",
    routeNav: "/avatar-mirror-page",
    component: <AvatarMirrorPage />,
  },
  {
    name: "Result",
    key: "result-page",
    icon: <Newspaper />,
    route: "/result-page/:data",
    routeNav: "/result-page",
    component: <ResultPage />,
  },
  // {
  //   name: "Container",
  //   key: "app-container",
  //   icon: <Newspaper />,
  //   route: "/operations/app-container",
  //   component: <AppContainer />,
  // },
];

export default routes;
